module.exports = __webpack_public_path__ + "img/y-92.e2b9d945.png";